import { render, staticRenderFns } from "./DraftDADetails.vue?vue&type=template&id=44517c0c&scoped=true"
import script from "./DraftDADetails.vue?vue&type=script&lang=js"
export * from "./DraftDADetails.vue?vue&type=script&lang=js"
import style0 from "./DraftDADetails.vue?vue&type=style&index=0&id=44517c0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44517c0c",
  null
  
)

export default component.exports